// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchFilterReviews_container__hM_rj","emptyReviews":"SearchFilterReviews_emptyReviews__MRf_f","localeMessaging":"SearchFilterReviews_localeMessaging__vMA76"};